<template>
  <header class="custom-navbar">
    <img
      style="margin-left: 1%;"
      :src="logoSrc || fallbackLogo"
      width="300"
      class="d-inline-block align-top"
      alt="Company Logo"
    />
  </header>
</template>

<script>
import axios from "axios";
export default {
  name: "ChecklistSharedNavbar",
  props: {
    SharedFillGuid: String
  },
  data() {
    return {
      logoSrc: null,
      logoObjectUrl: null
    };
  },
  computed: {
    fallbackLogo() {
      return this.$store.getters.systemLogoHome || "/img/logo_tecnologia_branco.png";
    }
  },

  async mounted() {
    try {
      const sharedFill = await this.getSharedFillByGuid(this.SharedFillGuid);
      if (!sharedFill) {
        return;
      }
      await this.getCompanyLogo(sharedFill.companyId, sharedFill.sharedFillToken);
    } catch (err) {
      console.error("Erro no fluxo de Navbar:", err);
    }
  },
  beforeDestroy() {
    if (this.logoObjectUrl) {
      URL.revokeObjectURL(this.logoObjectUrl);
      this.logoObjectUrl = null;
    }
  },

  methods: {
    async getSharedFillByGuid(guid) {
      const resp = await this.$apiChecklist.get(
        `/checklist/getsharedfill/${guid}`
      );
      return resp.data?.data?.data ?? null;
    },

    async getCompanyLogo(companyId, token) {
      if (!companyId || !token) return;

      const resp = await axios.get(
        `${this.$store.state.urlScheduler}/empresa/logo/${companyId}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      if (this.logoObjectUrl) {
        URL.revokeObjectURL(this.logoObjectUrl);
      }

      this.logoObjectUrl = URL.createObjectURL(resp.data);
      this.logoSrc = this.logoObjectUrl;
    }
  }
};
</script>
<style scoped>
.custom-navbar {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
